import { Link } from "@tanstack/react-router";
import { ShoppingCart } from "lucide-react";
import { StatusBadge } from "@/components/shared/status-badge";
import type { ProductLineItem } from "@/hooks/use-products";
import { formatCurrency, formatDate } from "@/lib/format";

interface ProductOrdersProps {
  lineItems: ProductLineItem[];
}

export function ProductOrders({ lineItems }: ProductOrdersProps) {
  return (
    <div className="space-y-4">
      <div className="flex items-center gap-2">
        <ShoppingCart className="h-4 w-4 text-muted-foreground" />
        <h3 className="text-sm font-medium">Ordered by ({lineItems.length})</h3>
      </div>

      {lineItems.length === 0 ? (
        <p className="text-sm text-muted-foreground">Not in any orders yet.</p>
      ) : (
        <div className="space-y-2">
          {lineItems.map((line) => (
            <Link
              key={line.orderItemId}
              to="/dashboard/orders/$orderId"
              params={{ orderId: line.orderId }}
              className="flex items-center justify-between rounded-lg border border-border bg-muted/30 p-3 hover:bg-muted/50 transition-colors"
            >
              <div className="flex items-center gap-3">
                <span className="text-sm font-medium">{line.customerName}</span>
                <StatusBadge status={line.orderStatus} />
                <span className="text-sm text-muted-foreground">
                  {formatDate(line.orderCreatedAt)}
                </span>
              </div>
              <span className="text-sm text-muted-foreground">
                {line.quantity} × {formatCurrency(line.unitPriceCents)}
              </span>
            </Link>
          ))}
        </div>
      )}
    </div>
  );
}
